import { useState } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { PoweredBy } from '../components/Brand';
import { ApiError, usePublicPrivacy } from '../api';
import { dateTime } from '../format';

/**
 * The mahallu's published privacy notice and grievance officer, for anyone with the link (no sign-in).
 * Printed for families who consent on paper.
 */
export function PublicPrivacy() {
  const { t, i18n } = useTranslation();
  const { slug = '' } = useParams();
  const page = usePublicPrivacy(slug);
  const [lang, setLang] = useState<'en' | 'ml'>(i18n.language === 'ml' ? 'ml' : 'en');
  const d = page.data;
  const notFound = page.error instanceof ApiError && page.error.status === 404;
  return (
    <main className="public-page">
      <header>
        <div>
          <h1 className={lang === 'ml' ? 'ml' : undefined}>{d ? (lang === 'ml' && d.mahallu.nameMl ? d.mahallu.nameMl : d.mahallu.nameEn) : t('public.notice')}</h1>
          {d?.notice ? <p className="note">{t('public.version', { n: d.notice.versionNo, date: dateTime(d.notice.publishedAt, lang) })}</p> : null}
        </div>
        <div className="lang-switch" role="group" aria-label={t('public.language')}>
          <button type="button" className={`btn sm${lang === 'en' ? ' primary' : ''}`} aria-pressed={lang === 'en'} onClick={() => setLang('en')}>
            English
          </button>
          <button type="button" className={`btn sm ml${lang === 'ml' ? ' primary' : ''}`} aria-pressed={lang === 'ml'} onClick={() => setLang('ml')}>
            മലയാളം
          </button>
        </div>
      </header>
      {page.isPending ? <p className="note">{t('drawer.loading')}</p> : null}
      {page.isError ? <p className="callout">{notFound ? t('public.notFound') : t('table.error')}</p> : null}
      {d && !d.notice ? <p className="callout">{t('public.none')}</p> : null}
      {d?.notice ? (
        <article className="card">
          <p className={`notice-text${lang === 'ml' ? ' ml' : ''}`} lang={lang}>
            {lang === 'ml' ? d.notice.bodyMl : d.notice.bodyEn}
          </p>
        </article>
      ) : null}
      {d?.officer ? (
        <section className="card" style={{ marginTop: 16 }}>
          <b>{t('public.officer')}</b>
          <p>
            {d.officer.name}
            {d.officer.phone ? (
              <>
                {' · '}
                <a href={`tel:${d.officer.phone}`}>{d.officer.phone}</a>
              </>
            ) : null}
            {d.officer.email ? (
              <>
                {' · '}
                <a href={`mailto:${d.officer.email}`}>{d.officer.email}</a>
              </>
            ) : null}
          </p>
        </section>
      ) : null}
      <PoweredBy />
    </main>
  );
}
